import { AuditApi, TransactionsApi } from '~/api';
import { action, makeObservable, observable, persist } from '~/modules';
import { ListPagination, transformTransactionToKeyValue } from '~/utils';

const initialFilters = {
  eventType: [],
  product: [],
  startDate: undefined,
  endDate: undefined,
};

export default class AuditStore {
  @persist('object')
  @observable
  client: AuditClientAccount = {} as AuditClientAccount;

  @observable
  logs: ListResponse<ClientLog> = {};

  @persist('object')
  @observable
  currentLog: ClientLog = {} as ClientLog;

  @observable
  filters: GetClientLogsFilters = initialFilters;

  @observable
  currentPage: number = ListPagination.INITIAL_PAGE;

  constructor() {
    makeObservable(this);
  }

  @action
  getClientAccount = async (document: string): Promise<void> => {
    this.clearFilters();
    this.setCurrentPage(ListPagination.INITIAL_PAGE);
    this.client = await AuditApi.getClientAccount(document);
  };

  @action
  getClientLogs = async (params: GetClientLogsParams): Promise<void> => {
    this.logs = await AuditApi.getClientLogs(params);
  };

  @action
  downloadClientLogs = async (params: GetClientLogsParams): Promise<any> => {
    return AuditApi.downloadClientLogs(params);
  };

  @action
  downloadDetailedLog = async (
    params: DownloadDetailedLogParams,
  ): Promise<any> => {
    return AuditApi.downloadDetailedLog(params);
  };

  @action
  mergeTransactionToLogMetadata = async (
    params: GetTransactionDetailsProps,
  ) => {
    const transaction = await TransactionsApi.getTransactionDetails(params);

    const formattedTransaction = transformTransactionToKeyValue(transaction);

    this.currentLog = {
      ...this.currentLog,
      metadata: [...formattedTransaction],
    };
  };

  @action
  setCurrentLog = (log: ClientLog) => {
    this.currentLog = log;
  };

  @action
  setFilters = (filters: GetClientLogsFilters) => {
    this.filters = { ...filters };
  };

  @action
  clearFilters = () => {
    this.filters = initialFilters;
  };

  @action
  setCurrentPage = (page: number) => {
    this.currentPage = page;
  };
}
